export { default } from './use-partner-click';
